const ROUTES = {
  ROOT: '/',
  VERSION: '/version',
  ERROR: '/error/:code?',

  COOKIE: '/cookie',

  SAC_TEST: '/sac-test',
  SAC_TEST2: '/sac-test2',

  REGISTER_START: '/register/start',
  REGISTER_ENTER_USERNAME: '/register/enter-username',
  REGISTER_ONE_TIME_CODE: '/register/onetimecode',
  REGISTER_SET_YOUR_PASSWORD: '/register/set-your-password',

  MANUAL_REG_FIND_CUSTOMER: '/manual-reg/find-your-email',
  MANUAL_REG_FIND_BUSINESS_CUSTOMER: '/manual-reg/find-your-business-email',
  MANUAL_REG_ACCOUNT_NUMBER: '/manual-reg/account-number',
  MANUAL_REG_ONE_TIME_CODE: '/manual-reg/onetimecode',
  MANUAL_REG_SET_YOUR_PASSWORD: '/manual-reg/set-your-password',

  RESET_PASSWORD_START: '/reset-password/start',
  RESET_PASSWORD_ENTER_USERNAME: '/reset-password/enter-username',
  RESET_PASSWORD_ONE_TIME_CODE: '/reset-password/onetimecode',
  RESET_PASSWORD_SET_YOUR_PASSWORD: '/reset-password/set-your-password',

  CHANGE_PASSWORD: '/change-password',
  CHANGE_PASSWORD_SUCCESS: '/change-password/success',

  FORGOT_USERNAME_FIND_BUSINESS_CUSTOMER: '/forgot-username/find-business-customer',

  FORGOT_USERNAME_START: '/forgot-username/start',
  FORGOT_USERNAME_FIND_CUSTOMER: '/forgot-username/find-customer',
  FORGOT_USERNAME_ACCOUNT_NUMBER: '/forgot-username/account-number',
  FORGOT_USERNAME_ACCOUNT_FOUND: '/forgot-username/account-found',

  LOGIN: '/login',
  LOGIN_START: '/login/start',

  IFRAME_LOGIN: '/iframe-login',
  IFRAME_LOGIN_START: '/iframe-login/start',
  IFRAME_LOGIN_ERROR: '/iframe-login/error/:code?',

  CALL_CENTRE_REGISTER_SET_YOUR_PASSWORD: '/call-centre-register/set-your-password',
  CALL_CENTRE_REGISTER_THANKYOU: '/call-centre-register/thankyou',

  CALL_CENTRE_RESET_PASSWORD_SET_YOUR_PASSWORD: '/call-centre-reset/set-your-password',
  CALL_CENTRE_RESET_PASSWORD_THANKYOU: '/call-centre-reset/thankyou',

  CLOSE_LOGIN_MODAL: '/close-login-modal',
  CONTINUE_WITHOUT_LOGIN: '/continue-without-login',

  PERMISSION_ERROR: '/permission/error/:code?',
};

export { ROUTES };
